export const environment = {
    production: true,
    baseUrl: 'https://srv763161.hstgr.cloud/',
    apiUrl: 'https://srv763161.hstgr.cloud:8080',
    liveApiUrl: 'https://srv763161.hstgr.cloud:8080/',
    appTitle: ' | efarm.cm - Agricultural Marketplace',
    apiUsername: 'payunit_NzajDpri9',
    apiPassword: 'b142a723-bba3-4c11-bfdf-3567533cef26',
    apiKey: 'ae9c4d040eaa9c65b372a5ab888ab1fb53844f21',
    mode: 'test',
    return_url: 'https://srv763161.hstgr.cloud/payment/return',
    notify_url: 'https://srv763161.hstgr.cloud:8080/payments/return',
    purchaseRef: '',
    total_amount: '',
    name: 'eFarm.cm Market Place',
    currency: 'XAF',
    image_cdn_url: 'https://srv763161.hstgr.cloud:8080',
    appName: 'EWeb',
    flutterwaveKey: 'FLWPUBK_TEST-22719ae7d6c9cc8a1228f5211ce96f58-X',
    companyNumber: '681763523',
    fixerKey: 'fd63b536fa83182bfc5ea0ad979f9ad3',
    exchangeRateApiKey: 'ca039b9e0c82e80097c310f6',
    allowedHosts: ['localhost', '127.0.0.1', 'srv763161.hstgr.cloud', 'www.srv763161.hstgr.cloud', '185.97.144.191']
  };
